import * as moment from 'moment';

export class CustomDayStyle {
    public date: Date;
    public mode: string;
    public clazz: string;

    constructor(date: Date, mode: string, clazz: string) {
        this.date = date;
        this.mode = mode;
        this.clazz = clazz;
    }
}

export class CustomDateStyle {
    public year: number;
    public month: number;
    public day: number;


    constructor(year: number, month: number, day: number) {
        this.day = day;
        this.month = month;
        this.year = year;
    }
}

export class HighLightDates {
    public highLightDateList: Array<CustomDayStyle>;
}

export class HighLightDateRange {
    public highLightDateRange: Array<CustomDateStyle>;
}

export class DatepickerDate {
  date: CustomDateStyle;
  epoc: number;
  formatted: string;
  jsdate: Date

  constructor(d: CustomDateStyle, dateObj?: Date) {
    if (!!d) {
      this.date = d;
      this.jsdate = new Date(d.year, d.month - 1, d.day);
      this.epoc = this.jsdate.getTime() / 1000;
      this.formatted = moment(this.jsdate).format('MM/DD/YYYY');
    }
    else if (!!dateObj) {
      this.date = {
        year: dateObj.getFullYear(),
        month: dateObj.getMonth() + 1,
        day: dateObj.getDate()
      };
      this.jsdate = dateObj;
      this.epoc = this.jsdate.getTime() / 1000;
      this.formatted = moment(this.jsdate).format('MM/DD/YYYY');
    }
  }

}